<template>
  <div>
    <v-navigation-drawer app permanent width="260" class="sidebar-drawer">
      <!-- Header Section -->
      <div class="sidebar-header pa-4">
        <div class="text-h5 font-weight-bold white--text mb-0">RCS</div>
        <div class="text-caption white--text mt-1">BMS</div>
      </div>

      <v-divider class="sidebar-divider"></v-divider>

      <!-- Main Navigation -->
      <!-- SCROLL CONTAINER -->
      <div class="sidebar-nav px-3">
        <v-list>
          <v-list-item v-for="item in menuItems" :key="item.title" :prepend-icon="item.icon" :title="item.title"
            :value="item.route" :active="isMenuItemActive(item)" class="sidebar-item"
            @click="handleMenuClick(item)" />
        </v-list>

        <div class="sidebar-section-heading px-4 pt-4 pb-2">RCS SUPPORT CENTER</div>
        <v-list>
          <v-list-item
            v-for="item in supportCenterItems"
            :key="item.route"
            :prepend-icon="item.icon"
            :title="item.title"
            :value="item.route"
            :active="isMenuItemActive(item)"
            class="sidebar-item"
            @click="handleMenuClick(item)"
          />
        </v-list>
      </div>

      <!-- User Section at Bottom -->
      <template v-slot:append>
        <v-divider class="sidebar-divider"></v-divider>
        <div class="pa-4 sidebar-user">
          <div class="text-body-1 white--text font-weight-medium">
            {{ displayEmail }}
          </div>
        </div>
        <div class="pa-2">
          <v-list-item prepend-icon="mdi-logout" title="Sign Out" class="sidebar-item sidebar-signout"
            @click="handleLogout"></v-list-item>
        </div>
      </template>
    </v-navigation-drawer>

    <v-main>
      <v-container fluid class="pa-4">
        <router-view></router-view>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { signOut } from "aws-amplify/auth";
export default {
  name: "LandingPage",
  data() {
    return {
      activeRoute: "/organization",
      userName: "Demo Admin",
      userEmail: "user@example.com",
      menuItems: [
        {
          title: "Organizations",
          icon: "mdi-office-building",
          route: "/organization",
        },
        {
          title: "Administrators",
          icon: "mdi-account-cog",
          route: "/administration",
        },
        {
          title: "Medication",
          icon:"mdi-pill-multiple",
          route: "/drugLibrary",
        },
        // { title: 'Category', icon: 'mdi-tag', route: '/category' },
        // { title: "Medication", icon: "mdi-chart-box", route: "/medication" },
        { title: "Masters", icon: "mdi-table", route: "/masters" },
        // { title: 'Templates', icon: 'mdi-file-chart', route: '/templates' },
        {title: "Labs", icon : "mdi-flask-outline", route: "/labs"},
        { title: "Announcement", icon: "mdi-bullhorn", route: "/announcement" },
        { title: "Testimonials", icon: "mdi-message-fast-outline", route: "/testimonials" },
        { title: "BLOG", icon: "mdi-post", route: "/blogPost" },
        // { title: 'knowledge Base', icon: "mdi-database-check-outline", route: "/knowledgeBase" },
        { title: "User Guide", icon: "mdi-help-circle-outline", route: "/UserGuide" },
        // { title: "Release Notes", icon: "mdi-note-text-outline", route: "/releaseNotes" },
        { title: "Audit Log", icon: "mdi-math-log", route: "/auditLogs" },
        { title: "Audits", icon: "mdi-check-all", route: "/checklist" },
        { title: "Settings", icon: "mdi-cog", route: "/licenseSettings" },
      ],
      supportCenterItems: [
        { title: "Cases", icon: "mdi-folder-outline", route: "/rcs-support/cases" },
        { title: "Knowledge", icon: "mdi-book-open-outline", route: "/rcs-support/knowledge" },
        { title: "Support Agents", icon: "mdi-account-group-outline", route: "/rcs-support/support-agents" },
        { title: "Support Module", icon: "mdi-view-module-outline", route: "/rcs-support/support-modules" },
        // { title: "Settings", icon: "mdi-cog-outline", route: "/rcs-support/settings" },
      ],
    };
  },
  computed: {
    displayEmail() {
      return (
        this.$store.state.user?.email || this.userEmail || "user@example.com"
      );
    },
    allMenuItems() {
      return [...this.menuItems, ...this.supportCenterItems];
    },
  },
  mounted() {
    // Get user data from Vuex store if available
    if (this.$store.state.user) {
      this.userName = this.$store.state.user.name || "User Name";
      this.userEmail = this.$store.state.user.email || "user@example.com";
    }
    // Set active item based on current route
    this.updateActiveItem();
  },
  watch: {
    $route() {
      this.updateActiveItem();
    },
  },
  methods: {
    isMenuItemActive(item) {
      return this.activeRoute === item.route;
    },
    handleMenuClick(item) {
      this.activeRoute = item.route;
      if (item.route) {
        // Convert route to landing path
        const landingRoute = `/landing${item.route}`;
        this.$router.push(landingRoute);
      }
    },
    async handleLogout() {
      // Clear user data from store
      this.$store.dispatch("logout");
      await signOut({ global: true });
      // Redirect to login page
      this.$router.push("/login");
    },
    updateActiveItem() {
      const currentPath = this.$route.path;
      // Prefer longer route matches first (e.g. support settings vs license settings)
      const item = [...this.allMenuItems]
        .sort((a, b) => b.route.length - a.route.length)
        .find(
          (menuItem) =>
            currentPath.includes(menuItem.route) ||
            currentPath.includes(`/landing${menuItem.route}`)
        );
      this.activeRoute = item ? item.route : "";
    },
  },
};
</script>

<style scoped>
/* ==================================================
   DRAWER BASE
   ================================================== */
.sidebar-drawer {
  background-color: rgb(15, 25, 45) !important;
  overflow: hidden !important;
}

/* Disable Vuetify internal scrolling */
.sidebar-drawer :deep(.v-navigation-drawer__content) {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden !important;
}

/* ==================================================
   HEADER
   ================================================== */
.sidebar-header {
  background-color: rgb(15, 25, 45);
  min-height: 80px;
  flex-shrink: 0;
}

.sidebar-header :deep(.white--text),
.sidebar-header .white--text {
  color: #ffffff !important;
}

/* ==================================================
   DIVIDER
   ================================================== */
.sidebar-divider {
  border-color: rgba(255, 255, 255, 0.12) !important;
}

/* ==================================================
   ✅ NAV LIST (ONLY SCROLLABLE AREA)
   ================================================== */
.sidebar-nav {
  background-color: rgb(15, 25, 45);
  padding: 8px 0;

  /* 🔴 CORE FIX */
  /* max-height: calc(100vh - 200px); */
  overflow-y: auto;

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.4) transparent;
}

/* ==================================================
   SCROLLBAR – DEFAULT
   ================================================== */
.sidebar-nav::-webkit-scrollbar {
  width: 6px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.35);
  border-radius: 6px;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.55);
}

/* ==================================================
   FORCE SCROLLBAR VISIBILITY (SMALL SCREENS)
   ================================================== */
@media (max-height: 700px) {
  .sidebar-nav {
    overflow-y: scroll;
    /* 🔥 force scrollbar track */
  }

  .sidebar-nav::-webkit-scrollbar {
    width: 8px;
  }

  .sidebar-nav::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.65);
  }
}

/* ==================================================
   SECTION HEADING
   ================================================== */
.sidebar-section-heading {
  color: rgba(255, 255, 255, 0.45);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

/* ==================================================
   MENU ITEMS
   ================================================== */
.sidebar-item {
  color: rgba(255, 255, 255, 0.7) !important;
  margin: 4px 4px;
  border-radius: 8px;
  min-height: 44px;
  padding-inline: 8px !important;
}

.sidebar-item :deep(.v-list-item__prepend) {
  margin-inline-end: 8px !important;
  min-width: 24px !important;
}

.sidebar-item :deep(.v-icon) {
  font-size: 20px !important;
}

.sidebar-item :deep(.v-list-item-title) {
  font-size: 13px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
}

.sidebar-item :deep(.v-list-item__content) {
  overflow: visible;
}

.sidebar-item:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

/* ACTIVE ITEM */
.sidebar-item.v-list-item--active {
  background-color: rgb(0, 102, 204) !important;
}

.sidebar-item.v-list-item--active :deep(.v-icon),
.sidebar-item.v-list-item--active :deep(.v-list-item-title) {
  color: #ffffff !important;
  font-weight: 500;
}

/* ==================================================
   USER / FOOTER SECTION
   ================================================== */
.sidebar-user {
  background-color: rgb(15, 25, 45);
  flex-shrink: 0;
}

.sidebar-user :deep(.white--text),
.sidebar-user .white--text {
  color: #ffffff !important;
}

.sidebar-signout {
  margin: 0 8px 8px 8px;
}
</style>
